export class GlobalConstants {
    public static REQUEST_DETAIL_PANEL = 'detailPanel';
    public static REQUEST_RESULT_PANEL = 'resultPanel';
    public static REQUEST_PROCESS_PANEL = 'processPanel';
    public static DOWNLOAD_ATTACHMENT_ACTION = 'downloadAttachment';
    public static ADD_ATTACHMENT_ACTION = 'addAttachment';
    public static ASSIGN_REQUEST_DIALOG = 'assign';
    public static RETURN_REQUEST_DIALOG = 'return';
    public static EXECUTE_REQUEST_DIALOG_OPERATION = 'executeOperation';
    public static ASSIGNE_REASSIGNE_REQUEST_DIALOG_OPERATION = 'assignReassignOperation';
    public static ASSIGNE_TO_OPERATION_POPUP = 'assignToOperation';

    public static DOMAIN_STC = '@stc.com.sa';
    public static DOMAIN_STC_VALUE = 'stc.com.sa';
    public static HOST_NAME = 'https://igateapp.stc.com.sa';
    public static DEFAULT_IMAGE = 'assets/images/user.jpeg';
    public static ATTACHMENTS_HOST = 'tuwaiq-docs';
    public static PROD_OBJECT_STORE = 'https://ecsaf083.stc.com.sa:443';
    public static TUWAIQ_HOST = 'https://tuwaiq.stc.com.sa';
}
